export const getDesignsDefaultLink = (): any => '/designs';
export const getSharedWithMeDefaultLink = (): any => '/shared';
export const getProjectsDefaultLink = () => '/projects';
export const getBrandColorsLink = () => '/brand-colors';
export const getNotFoundLink = () => '/not-found';
export const getCategoriesLink = () => '/categories';
export const getUploadsDefaultLink = () => '/uploads';
export const getActivityFeedDefaultLink = () => '/activity';
export const getExportSettingsLink = () => '/export-settings';
